import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../store';
import style from '../../../scss/footer.scss';
import {getTenantData} from '../../tenants';
import {selectTenant} from '../selectors';

@customElement('arc-footer')
export class Footer extends connect(store)(LitElement) {
	static styles = [style];

	stateChanged(state) {
		this.status = state.status;
		this.tenant = selectTenant(state);
		this.footerLinks = getTenantData(this.tenant, 'footerLinks');
	}

	render() {
		return html`
			<div class="footer ${this.tenant}">
				<div class="logo">
					<img src="${getTenantData(this.tenant, 'logoInverted')}" alt="${getTenantData(this.tenant, 'name')}" />
				</div>
				<div class="links">
					${this.footerLinks.map((link) => html`<a class="link" target="_blank" href="${link.link}">${link.label}</a>`)}
				</div>
			</div>
		`;
	}
}
